module.exports = __webpack_public_path__ + "static/media/adoptionProcessImage.e1c17db1.png";